// ── FONTS & COLOR PALETTES ──
// F.d  = display para portal pacientes (serif editorial — calidez)
// F.dm = display para portal médico (sans moderno — clínico, legible)
// F.b  = body (todo)
// F.m  = mono (datos clínicos: circometría, hash, VAS, consecutivos)
export const F = {
  d: "'Libre Baskerville','Georgia',serif",
  dm: "'Inter','Source Sans 3','Segoe UI',sans-serif",
  b: "'Source Sans 3','Segoe UI',sans-serif",
  m: "'JetBrains Mono',monospace",
};

// ── Portal Pacientes (wellness-forward, cream cálido + teal confianza) ──
export const P = {
  bg: "#fbf9f5",        // cream cálido (ligeramente más frío que antes)
  card: "#ffffff",
  bdr: "#e8e2d9",       // beige suave
  tx: "#1e293b",        // slate 800 — no negro puro
  txM: "#64748b",       // slate 500 — secundario
  ac: "#2a8579",        // teal medio — moderno, menos plano
  acL: "#e0f2f1",       // teal bg muy claro (highlights)
  // Semánticos (obligatorios para UX médica)
  ok: "#16a34a",        // verde success
  wr: "#f59e0b",        // ámbar warning (nuevo — antes faltaba)
  er: "#dc2626",        // rojo crítico
  info: "#2563eb",      // azul info
};

// ── Portal Médico (clinical dashboard, slate oscuro + teal suave) ──
export const D = {
  bg: "linear-gradient(145deg,#0f172a 0%,#13213a 40%,#0f172a 100%)", // slate 900 (NO negro puro → menos fatiga)
  card: "rgba(30,41,59,0.72)",   // slate 800 translúcido
  bdr: "rgba(100,116,139,0.18)", // slate 500 con alpha
  tx: "#f1f5f9",        // slate 100
  txM: "#94a3b8",       // slate 400 — secundario legible
  ac: "#14b8a6",        // teal 500 (menos neón que #2dd4bf, profesional)
  acL: "#5eead4",       // teal 300 — highlights sutiles
  // Semánticos
  ok: "#22c55e",        // verde success
  wr: "#f59e0b",        // ámbar warning
  er: "#ef4444",        // rojo crítico
  info: "#3b82f6",      // azul acción informativa
};
